module.exports = __webpack_public_path__ + "img/crown.b04104e7.svg";